import { useEffect, type ReactNode } from "react";

/**
 * Scoped cosmic environment for WHAT IF? LAB. The `.whatif` class carries the
 * palette tokens, so nothing here leaks into the global theme. The Page
 * Visibility flag pauses every ambient animation while the tab is hidden.
 */
export function CosmicShell({ children }: { children: ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    const sync = () => {
      root.dataset.whatifHidden = document.visibilityState === "hidden" ? "1" : "0";
    };
    sync();
    document.addEventListener("visibilitychange", sync);
    return () => {
      document.removeEventListener("visibilitychange", sync);
      delete root.dataset.whatifHidden;
    };
  }, []);

  return (
    <div className="whatif min-h-[100svh] w-full overflow-x-hidden">
      <div aria-hidden className="whatif-ambient">
        <span className="whatif-aurora" />
      </div>
      <div className="relative mx-auto w-full max-w-2xl px-4 pb-24 pt-5">{children}</div>
    </div>
  );
}